import { Command } from './Commands';

export class NotifyPageUpdate extends Command {
  type: string = 'Page.NotifyUpdate';
  priority: number = 150;
}
